/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useCallback, useEffect, useState } from 'react';
import { jsx } from '@emotion/core';
import { useSelector } from 'react-redux';
import { downloadUserExport, fetchShutdownBanner } from '../../Components/action/shutdown';
import {
  shutdownHeading,
  shutdownInnerFormStyle,
  shutdownText,
} from '../../Components/Shutdown/shutdownSettingsStyles';

function DataExport({ activeTab, setActiveTab }) {
  const { theme } = useSelector((state) => state.theme);
  const [banner, setBanner] = useState(null);
  const [bannerLoaded, setBannerLoaded] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchShutdownBanner()
      .then((res) => setBanner(res?.data?.responseData ?? null))
      .catch(() => setBanner(null))
      .finally(() => setBannerLoaded(true));
  }, []);

  useEffect(() => {
    if (bannerLoaded && !banner?.enabled && activeTab === 'data-export') {
      setActiveTab(null);
    }
  }, [bannerLoaded, banner?.enabled, activeTab, setActiveTab]);

  const handleDownload = useCallback(async () => {
    setError(null);
    setDownloading(true);
    try {
      await downloadUserExport('/api/export');
    } catch (e) {
      setError(e?.message || 'Export failed. Please try again.');
    } finally {
      setDownloading(false);
    }
  }, []);

  if (!bannerLoaded || !banner?.enabled) {
    return null;
  }

  return (
    <li className={`li-setting-tab ${activeTab === 'data-export' ? 'active' : ''}`}>
      <div
        className="settings-accordion-tab dark:bg-black"
        onClick={() => setActiveTab((t) => (t === 'data-export' ? null : 'data-export'))}
        style={{ background: theme === 'dark' ? 'black' : '' }}
        css={{
          background:
            activeTab === 'data-export'
              ? theme === 'dark'
                ? 'linear-gradient(0deg,var(--accent-color-10),var(--accent-color-10)),#000 !important'
                : 'linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important'
              : '',
          '&:hover': {
            background:
              theme === 'dark'
                ? 'linear-gradient(0deg, var(--accent-color-10), var(--accent-color-10)), #000 !important'
                : 'linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important',
          },
        }}
      >
        <div className="settings-accordion-heading">
          <figure className="settings-icon">
            <img src="images/general.svg" className="img-default dark:invert-color" alt="" />
          </figure>
          <h3 className="accordion-title uppercase dark:text-white">Download My Data</h3>
        </div>
        <div className="settings-accordion-arrow">
          <img src="images/arrow-down.svg" className="dark:invert-color" alt="" />
        </div>
      </div>

      {activeTab === 'data-export' && (
        <div className="settings-accordion-content shutdown-accordion-content">
          <div
            className="inner-form shutdown-settings-panel relative"
            style={shutdownInnerFormStyle(theme)}
          >
            <h3 className="form-heading uppercase" style={shutdownHeading(theme)}>
              Export your Lifetab data
            </h3>
            {banner?.message && (
              <p className="field-label" style={{ ...shutdownText(theme), marginTop: '12px', marginBottom: '12px', fontSize: '14px' }}>
                {banner.message}
              </p>
            )}
            <p className="field-label" style={{ ...shutdownText(theme, 0.8), marginBottom: '20px', fontSize: '14px' }}>
              Download a JSON file with your projects, tasks, journal notes, and tags.
            </p>
            <div className="field-block">
              <button
                type="button"
                className="changeName"
                disabled={downloading}
                onClick={handleDownload}
                css={{
                  background:
                    theme === 'dark'
                      ? `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #000000 !important`
                      : `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), #ffffff !important`,
                  color: 'var(--accent-color) !important',
                  opacity: downloading ? 0.7 : 1,
                  cursor: downloading ? 'wait' : 'pointer',
                }}
              >
                {downloading ? 'Preparing download…' : 'Download My Data'}
              </button>
            </div>
            {error && (
              <p style={{ color: '#f87171', fontSize: '13px', marginTop: '16px', opacity: 1 }}>{error}</p>
            )}
          </div>
        </div>
      )}
    </li>
  );
}

export default DataExport;
